let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("blfHq")).then(() => parcelRequire('6QtDx'));